import { featureFlagsConfig } from '../featureFlags';
import { FeatureFlagName } from '../types/FeatureFlag';

export function featureFlagsFromUbikUserContext(userContextFeatureFlags?: {
    [key: string]: string | undefined;
}) {
    if (!userContextFeatureFlags) {
        return [];
    }
    return Object.keys(userContextFeatureFlags)
        .filter((featureFlagName): featureFlagName is FeatureFlagName =>
            featureFlagsConfig.includes(featureFlagName as FeatureFlagName)
        )
        .map((featureFlagName) => {
            let enabled;
            if (userContextFeatureFlags[featureFlagName] !== undefined) {
                enabled = userContextFeatureFlags[featureFlagName] === 'true';
            }

            return {
                featureName: featureFlagName,
                enabled: enabled,
            };
        });
}
